var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsdcEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0216 18.1243C20.0216 16.0003 18.7416 15.2723 16.1816 14.9683C14.3536 14.7253 13.9886 14.2403 13.9886 13.3903C13.9886 12.5403 14.5986 11.9943 15.8166 11.9943C16.9136 11.9943 17.5236 12.3582 17.8276 13.2692C17.8592 13.3573 17.9172 13.4336 17.9935 13.4878C18.0698 13.542 18.161 13.5714 18.2546 13.5722H19.2296C19.2859 13.5738 19.3419 13.5638 19.3943 13.543C19.4466 13.5222 19.4942 13.491 19.5341 13.4512C19.5741 13.4115 19.6055 13.3641 19.6265 13.3118C19.6476 13.2596 19.6578 13.2036 19.6566 13.1473V13.0872C19.5374 12.4281 19.2039 11.8269 18.7079 11.3768C18.2119 10.9267 17.5811 10.653 16.9136 10.5982V9.14225C16.9136 8.89925 16.7306 8.71725 16.4266 8.65625H15.5116C15.2686 8.65625 15.0856 8.83825 15.0246 9.14225V10.5382C13.1956 10.7803 12.0386 11.9942 12.0386 13.5122C12.0386 15.5142 13.2566 16.3033 15.8166 16.6073C17.5236 16.9103 18.0716 17.2753 18.0716 18.2463C18.0716 19.2163 17.2186 19.8843 16.0606 19.8843C14.4756 19.8843 13.9276 19.2172 13.7446 18.3062C13.6846 18.0642 13.5006 17.9422 13.3176 17.9422H12.2816C12.2253 17.9409 12.1694 17.9509 12.1172 17.9718C12.0649 17.9927 12.0175 18.0239 11.9777 18.0636C11.9378 18.1034 11.9065 18.1507 11.8855 18.2029C11.8645 18.2551 11.8543 18.311 11.8556 18.3673V18.4272C12.0986 19.9452 13.0746 21.0372 15.0856 21.3412V22.7983C15.0856 23.0402 15.2686 23.2233 15.5726 23.2833H16.4876C16.7306 23.2833 16.9136 23.1013 16.9746 22.7983V21.3403C18.8036 21.0372 20.0216 19.7622 20.0216 18.1232V18.1243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8913 24.497C8.13731 22.797 5.69931 17.517 7.46731 12.844C8.38131 10.294 10.3923 8.353 12.8913 7.442C13.1353 7.321 13.2563 7.139 13.2563 6.835V5.985C13.2563 5.743 13.1353 5.561 12.8913 5.5C12.8303 5.5 12.7083 5.5 12.6473 5.56C11.2757 5.98832 10.0024 6.68373 8.90073 7.60617C7.79902 8.52862 6.89066 9.65988 6.22795 10.9348C5.56525 12.2098 5.16128 13.6032 5.03932 15.0349C4.91736 16.4666 5.0798 17.9083 5.51731 19.277C6.61331 22.677 9.23431 25.287 12.6473 26.379C12.8913 26.5 13.1353 26.379 13.1953 26.136C13.2563 26.076 13.2563 26.014 13.2563 25.893V25.043C13.2563 24.861 13.0743 24.619 12.8913 24.497ZM19.3513 5.561C19.1073 5.439 18.8633 5.561 18.8033 5.803C18.7423 5.864 18.7423 5.925 18.7423 6.046V6.896C18.7423 7.139 18.9243 7.381 19.1073 7.503C23.8613 9.203 26.2993 14.483 24.5313 19.156C23.6173 21.706 21.6063 23.647 19.1073 24.558C18.8633 24.679 18.7423 24.861 18.7423 25.165V26.015C18.7423 26.257 18.8633 26.439 19.1073 26.5C19.1683 26.5 19.2903 26.5 19.3513 26.44C20.7229 26.0117 21.9962 25.3163 23.0979 24.3938C24.1996 23.4714 25.108 22.3401 25.7707 21.0652C26.4334 19.7902 26.8373 18.3968 26.9593 16.9651C27.0813 15.5334 26.9188 14.0917 26.4813 12.723C25.3853 9.263 22.7033 6.653 19.3513 5.561Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_623_797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 32C28.4183 32 32 28.4183 32 24C32 19.5817 28.4183 16 24 16C19.5817 16 16 19.5817 16 24C16 28.4183 19.5817 32 24 32Z",
    fill: "#ECEFF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_623_797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.999 18L23.9225 18.2621V25.866L23.999 25.943L27.4979 23.8566L23.999 18Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 18L20.5 23.8566L23.999 25.943V22.2523V18Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 26.6113L23.9559 26.6643V29.373L23.999 29.4999L27.5 24.526L23.999 26.6113Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 29.4999V26.6113L20.5 24.526L23.999 29.4999Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 25.943L27.4979 23.8566L23.999 22.2523V25.943Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.8566L23.999 25.943V22.2523L20.5 23.8566Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_623_797"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_623_797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 11.5,
    fill: "white",
    transform: "translate(20.5 18)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsdcEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/USDC_ETH.ccd15f22d3c311b943bede8ce8cfa871.svg";